import { Construction, Clock, Wrench } from 'lucide-react';
import styles from './UnderDevelopment.module.css';

function UnderDevelopment({ featureName = 'This feature' }) {
  return (
    <div className={styles.container}>
      <div className={styles.iconGroup}>
        <Construction className={styles.iconMain} size={48} />
        <Wrench className={styles.iconFloat} size={24} />
      </div>
      
      <h2 className={styles.title}>Under Development</h2>
      
      <p className={styles.message}>
        {featureName} is currently being built. Check back soon!
      </p>
      
      <div className={styles.status}>
        <Clock size={16} className={styles.clockIcon} />
        <span>Coming soon</span>
      </div>
    </div>
  );
}

export default UnderDevelopment;